import React from 'react';
import styles from '../styles/filter.scss';
const Filter = ({ selected, children, onClick, }) => {
    return (React.createElement("a", { href: '#', className: selected ? styles.filter_link_selected : styles.filter_link, onClick: (e) => {
            e.preventDefault();
            onClick();
        } }, children));
};
export default Filter;
